import { HttpContextToken } from '@angular/common/http';

/**
 * When set to `true` on a request's `HttpContext`, the global
 * error-feedback interceptor skips its toast and simply rethrows, letting
 * the component surface the error inline. Defaults to `false`.
 *
 * Usage:
 *   http.post(url, body, { context: new HttpContext().set(SKIP_FEEDBACK, true) });
 *
 * KIT NOTE: moved here verbatim from each dashboard's
 * `shared/http/feedback.context.ts` so both repos share one token identity.
 * The value, the default and every call site's semantics are unchanged.
 */
export const SKIP_FEEDBACK = new HttpContextToken<boolean>(() => false);
